import { useContext } from "react";
import NombreModuloContext from "../Context/NombreModuloContext";
export function useNombreModulo() {
    const NombreModuloHelpers = useContext(NombreModuloContext);
    return NombreModuloHelpers;
}